import hero from './hero-empty.png';
import homeHero from './homeHero.png';
import meWithDogs from './me3.png';
import meWithZoey from './me-zoey.jpg';
import portrait from './portrait.png';
import headshot from './headshot.png';
import navLogo from './Kendra-logo.png';

import natCare from './NatCare.png';
import natMyIRP from './natmyirpDemo.png';
import natMyIRPLg from './natMyIRPLg.png';
import natMutualFund from './natMutualFunds.png';
import natMutualFundLg from './natMutualFundsLg.png';

import aceDocs from './aceDocs.png';
import aceDocsLg from './aceDocsLg.png';
import projectTracker from './projectTracker.png';
import projectTrackerLg from './projectTrackerLg.png';

import foundation from './foundation.png';
import wheels from './wheels.png';

import abuserList from './abuserList.png';

import pubAwards from './pubAwards.png';
import pubAwardsHero from './publishAwardsHero.png';
import manCheckQueue from './manCheckQueue.png';

import manCheckHero from './mancheck-hero.png';
import takeBatch from './takeBatch.png';
import checkDashboard from './checkDashboard.png';
import applyPayment from './applyPayment.png';
import searchSave from './searchSave.png';
import accountingDashboard from './accountingDashboard.png';
import accountingDashWithZoom from './accountingDashwithZoom.png';
import checkDetailsWithDropdown from './checkDetailsWithDropdown.png';
import payWithError from './applyPayError.png';
import problemCheck from './problemCheck.png';

import pubAwardsBidRoundListPage from './pubAwardsBidRoundListPage.png';
import pubAwardsBidPackagePage from './pubAwardsBidPackagePage.png';
import pubAwardsBidRoundPage from './pubAwardsBidRoundPage.png';
import pubAwardsBidRoundPages from './pubAwardsBidRoundPages.png';
import pubAwardsPage from './pubAwardsPage.png';
import pubAwardsPageWithMessage from './pubAwardsPageWithMessage.png';

import comingSoon from './comingSoon.png';
import abuserListHero from './abuser-list-hero.png';
import masterList from './masterList.png';
import newCompanies from './abuser-newCompanies.png';
import comparisonModal from './comparisonModal.png';
import comparisonModalIndividual from './Comparison-modal-individual.png';
import abuserDetails from './abuserDetails.png';
import comparisonList from './comparisonList.png';
import newCompaniesAddIndividually from './newCompaniesAdd-individually.png';
import newCompaniesAddBulk from './newCompanies-add-bulk.png';
import comparisonListAdd from './comparisonList-add.png';
import masterListAdd from './masterList-add.png';

export default {
    hero,
    navLogo,
    natCare,
    meWithZoey,
    meWithDogs,
    portrait,
    headshot,

    abuserList,
    pubAwards,
    manCheckQueue,

    natCare,
    natMyIRP,
    natMyIRPLg,
    natMutualFund,
    natMutualFundLg,
    projectTracker,
    projectTrackerLg,
    aceDocs,
    aceDocsLg,

    pubAwardsHero,
    pubAwardsBidRoundListPage,
    pubAwardsBidPackagePage,
    pubAwardsBidRoundPage,
    pubAwardsBidRoundPages,
    pubAwardsPage,
    pubAwardsPageWithMessage,

    manCheckHero,
    takeBatch,
    checkDashboard,
    applyPayment,
    searchSave,
    accountingDashboard,
    accountingDashWithZoom,
    checkDetailsWithDropdown,
    payWithError,
    problemCheck,

    abuserListHero,
    masterList,
    newCompanies,
    comparisonModal,
    comparisonModalIndividual,
    comparisonList,
    abuserDetails,
    newCompaniesAddIndividually,
    newCompaniesAddBulk,
    comparisonListAdd,
    masterListAdd,
    comingSoon,

    foundation,
    wheels
};